import { useEffect, useMemo, useState } from 'react'
import {
  buildLogoDevCdnUrl,
  symbolMonogram,
  type TradeMarket,
} from '../lib/logoDev'

type SymbolLogoProps = {
  symbol: string
  market?: TradeMarket | string | null
  exchange?: string | null
  micCode?: string | null
  size?: number
  className?: string
  monogramClassName?: string
  alt?: string
}

export default function SymbolLogo({
  symbol,
  market = 'Stock',
  exchange,
  micCode,
  size = 22,
  className = 'at-symbol-avatar',
  monogramClassName,
  alt,
}: SymbolLogoProps) {
  const [failed, setFailed] = useState(false)
  const monogram = useMemo(() => symbolMonogram(symbol), [symbol])

  useEffect(() => {
    setFailed(false)
  }, [symbol, market, exchange, micCode])

  const src = useMemo(() => {
    if (!market || failed) return null
    return buildLogoDevCdnUrl(symbol, market, {
      exchange,
      micCode,
      size,
      format: 'png',
      retina: true,
    })
  }, [symbol, market, exchange, micCode, size, failed])

  const label = alt ?? `${symbol} logo`

  if (!src) {
    return <span className={monogramClassName ?? className} aria-hidden>{monogram}</span>
  }

  return (
    <span className={className} aria-hidden>
      <img
        src={src}
        alt={label}
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    </span>
  )
}
